export default "__VITE_ASSET__B$joWF0H__"